import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, InstagramIcon, GlobeIcon, MapPinIcon } from './icons/Icons';
export const CTA = () => {
  return <section id="contacto" className="py-12 md:py-16 bg-brand-blush relative" data-id="element-48">
      <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white p-10 md:p-16 rounded-3xl shadow-sm border border-brand-gold/20 relative overflow-hidden" data-id="element-50">
          {/* Decorative corners */}
          <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-brand-gold/30 rounded-tl-3xl m-4" data-id="element-51"></div>
          <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-brand-gold/30 rounded-br-3xl m-4" data-id="element-52"></div>

          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-3" data-id="element-53">
            ¿Lista para tu transformación?
          </h2>
          <p className="text-xl text-brand-bronze font-serif italic mb-6" data-id="element-54">
            Tu piel te lo agradecerá mañana.
          </p>

          <a href="https://wa.me/12679841013" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-5 bg-brand-gold text-white text-lg font-medium rounded-full hover:bg-brand-bronze transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 mb-8" data-id="element-55">
            Agenda tu cita hoy mismo
          </a>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto mb-8 text-left" data-id="element-56">
            <a href="https://wa.me/12679841013" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-4 group" data-id="element-57">
              <div className="w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center text-brand-gold group-hover:bg-brand-gold group-hover:text-white transition-colors" data-id="element-58">
                <PhoneIcon size={20} data-id="element-59" />
              </div>
              <div data-id="element-60">
                <p className="text-xs text-brand-charcoal/60 uppercase tracking-wider mb-1" data-id="element-61">
                  WhatsApp
                </p>
                <p className="text-brand-charcoal font-medium" data-id="element-62">267-984-1013</p>
              </div>
            </a>

            <a href="https://instagram.com/skinglowstudio22" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-4 group" data-id="element-63">
              <div className="w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center text-brand-gold group-hover:bg-brand-gold group-hover:text-white transition-colors" data-id="element-64">
                <InstagramIcon size={20} data-id="element-65" />
              </div>
              <div data-id="element-66">
                <p className="text-xs text-brand-charcoal/60 uppercase tracking-wider mb-1" data-id="element-67">
                  Instagram
                </p>
                <p className="text-brand-charcoal font-medium" data-id="element-68">
                  @skinglowstudio22
                </p>
              </div>
            </a>

            <a href="https://skinglowstudio22.com" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-4 group" data-id="element-69">
              <div className="w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center text-brand-gold group-hover:bg-brand-gold group-hover:text-white transition-colors" data-id="element-70">
                <GlobeIcon size={20} data-id="element-71" />
              </div>
              <div data-id="element-72">
                <p className="text-xs text-brand-charcoal/60 uppercase tracking-wider mb-1" data-id="element-73">
                  Website
                </p>
                <p className="text-brand-charcoal font-medium" data-id="element-74">
                  skinglowstudio22.com
                </p>
              </div>
            </a>

            <div className="flex items-center space-x-4" data-id="element-75">
              <div className="w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center text-brand-gold" data-id="element-76">
                <MapPinIcon size={20} data-id="element-77" />
              </div>
              <div data-id="element-78">
                <p className="text-xs text-brand-charcoal/60 uppercase tracking-wider mb-1" data-id="element-79">
                  Ubicación
                </p>
                <p className="text-brand-charcoal font-medium" data-id="element-80">
                  Philadelphia, PA
                </p>
              </div>
            </div>
          </div>

          <div className="pt-6 border-t border-brand-cream" data-id="element-81">
            <p className="text-2xl font-serif italic text-brand-charcoal mb-3" data-id="element-82">
              "Agenda tu limpieza facial y regálate ese cuidado que tanto
              mereces."
            </p>
            <p className="text-sm font-medium text-brand-bronze uppercase tracking-widest" data-id="element-83">
              — María Fernanda Salcedo
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};